import React from "react";

import PropTypes from 'prop-types';

import { useCarsState } from "../providers/CarsProvider";

import AddIcon from "./icons/AddIcon";

import TrashIcon from "./icons/TrashIcon";

import { deleteUser } from "../api/cars";

import { NavLink } from "react-router-dom";

import EditIcon from "./icons/EditIcon";

const UsersModule = ( { car, currentUser } ) => {

    const [ carsState, carsDispatch ] = useCarsState();

    return (
        <div className="pos-fixed tr-0 text-white z-2 d-flex flex-column align-items-center overflow-hidden p-1 rounded-4 hide-m" style={ { height:'calc( 100% - 60px )', gap:10, background: "#99999966" } } >

            <h6 className="bold small">users</h6>

            <NavLink style={{ borderRadius:4, backgroundColor:"#CCCCCC66", padding:6 }} className="text-hover-admin-accent" onClick={ e => e.stopPropagation() } to={`/cars/${car}/user/add`} ><AddIcon /></NavLink>

            <div className="flex-grow-1 overflow-hidden">

                <div className="h-100 overflow-y-auto d-flex flex-column p-1" style={{ gap: 10 }}>

                    { carsState.usersList.map( ( user ) => {

                        let label = user.email;

                        if( user.first_name ) label = user.first_name;

                        if( user.last_name ) label = label + " " + user.last_name;

                        return user.id == currentUser ? null : <div className={`lh-0 pos-rel rounded-4`} style={ { border: "2px solid", gap: 10 } } key = { `user-${ user.id }` } >

                            <div className="z-1 d-flex align-items-center" style={{ borderRadius:4, backgroundColor:"#CCCCCC66", padding:6, bottom:0, left:0, gap:6 } }>

                                <h6>{ label }</h6>

                                <NavLink className="pl-1 ml-auto" onClick={ e => e.stopPropagation() } to={`/cars/${car}/user/${user.id}`} ><EditIcon /></NavLink>

                                <button onClick={ e=>{ 

                                    e.stopPropagation(); 

                                    deleteUser( car, user.id ).then( data => {

                                        carsDispatch( { type: "deleteUser", id: data.id } );
                                    } )
                                }}><TrashIcon /></button>
                            </div>
                        </div>
                    } ) }
                </div>
            </div>
        </div>
    )
}

UsersModule.propTypes = {
    car: PropTypes.number.isRequired,
    currentUser: PropTypes.number.isRequired
}

export default UsersModule